import EnumBuilder from "utils/enumBuilderUtils";

const builder = new EnumBuilder();

const TaskStatus = builder.add("NotStarted", "Draft").add("InProgress", "Live").add("Completed", "Closed").build();

export default TaskStatus;
